// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-pager',
    // #endregion
    // #region Properties
    props: {
        page: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 10
        },
        visiblePage: {
            type: Number,
            default: 5
        },
        records: {
            type: Number,
            required: true
        },
    },
    data: () => ({
        currentPage: 1,
    }),
    computed: {
        pages() {
            return this.paginate(this.records, this.currentPage, this.pageSize, this.visiblePage).pages;
        },
        totalPages() {
            return Math.ceil(this.records / this.pageSize);
        },
    },
    // #endregion
    // #region Constructor
    created() {
        this.updateCurrentPage();
    },
    // #endregion
    // #region Watch
    watch: {
        page() {
            this.updateCurrentPage();
        },
        records() {
            if (this.currentPage > this.totalPages) {
                this.currentPage = this.totalPages;
                this.applyPageToRoute();
            }
        },
    },
    // #endregion
    // #region Core
    methods: {
        firstPage() {
            this.currentPage = 1;
            this.applyPageToRoute();
        },
        previusPage() {
            if (this.currentPage > 1) {
                this.currentPage -= 1;
                this.applyPageToRoute();
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage += 1;
                this.applyPageToRoute();
            }
        },
        lastPage() {
            this.currentPage = this.totalPages;
            this.applyPageToRoute();
        },
        gotoPage(number) {
            if (number > this.totalPages) {
                return;
            }
            if (number < 1) {
                return;
            }
            this.currentPage = number;
            this.applyPageToRoute();
        },
        onLimitChange() {
            this.currentPage = 1;
            this.applyPageToRoute();
        },
        updateCurrentPage() {
            if (this.page > this.totalPages) {
                this.currentPage = this.totalPages;
            }
            else if (this.page <= 0) {
                this.currentPage = 1;
            }
            else {
                this.currentPage = this.page;
            }
        },
        applyPageToRoute() {
            //new
            let tQuery = Object.assign({}, this.$route.query);
            //Set
            if (this.currentPage <= 1) {
                delete tQuery["p"];
            }
            else {
                tQuery["p"] = this.currentPage.toString();
            }
            this.$router.push({ query: tQuery });
        },
        paginate(totalItems, currentPage = 1, pageSize = 10, maxPages = 10) {
            // calculate total pages
            let totalPages = Math.ceil(totalItems / pageSize);
            // ensure current page isn't out of range
            if (currentPage < 1) {
                currentPage = 1;
            }
            else if (currentPage > totalPages) {
                currentPage = totalPages;
            }
            let startPage;
            let endPage;
            if (totalPages <= maxPages) {
                // total pages less than max so show all pages
                startPage = 1;
                endPage = totalPages;
            }
            else {
                // total pages more than max so calculate start and end pages
                let maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
                let maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
                if (currentPage <= maxPagesBeforeCurrentPage) {
                    // current page near the start
                    startPage = 1;
                    endPage = maxPages;
                }
                else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
                    // current page near the end
                    startPage = totalPages - maxPages + 1;
                    endPage = totalPages;
                }
                else {
                    // current page somewhere in the middle
                    startPage = currentPage - maxPagesBeforeCurrentPage;
                    endPage = currentPage + maxPagesAfterCurrentPage;
                }
            }
            // calculate start and end item indexes
            let startIndex = (currentPage - 1) * pageSize;
            let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
            // create an array of pages to ng-repeat in the pager control
            let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
            // return object with all pager properties required by the view
            return {
                totalItems: totalItems,
                currentPage: currentPage,
                pageSize: pageSize,
                totalPages: totalPages,
                startPage: startPage,
                endPage: endPage,
                startIndex: startIndex,
                endIndex: endIndex,
                pages: pages
            };
        }
    }
    // #endregion
});
// #endregion
